import React, { useEffect, useState } from 'react'
import { useCart } from '../../context/CartContext'
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';
import Navbar2 from '../Navbar2';
import axios from 'axios';
import { getCurrentUser } from '../../services/auth';
import Footer from '../Footer/Footer';

function CheckoutScreen() {

    const { cartItems, cartTotal, clearCart } = useCart();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({
        name:'',
        email:'',
        address:'',
        city:'',
        state:'',
        zip:'',
        paymentMethod:'credit-card'
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const order = {
                customer: formData,
                items: cartItems,
                total: cartTotal,
                date: new Date().toISOString()
            };

            const response = await axios.post('http://localhost:3001/orders', order);

            if(response.status === 201) {
                clearCart();
                navigate('/order-confirmation', {
                    state: {orderId: response.data.orderId}
                });
            }
        } catch (error) {
            console.error("Checkout error:", error);
            alert("Failed to place order. Please try again.");
        }
    };

    useEffect(() => {
        const currentUser = getCurrentUser();

        if(!currentUser) {
            navigate('/');
            return;
        }

        setUser(currentUser);
        setFormData(prev => ({
            ...prev,
            name: currentUser.name || '',
            email: currentUser.email || ''
        }));
        setLoading(false);
    }, [navigate]);


    if (loading) {
        return (
          <div className="container py-5 text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        );
    }

  return (
    <>
        <Navbar/>
        <div className="sticky-navbar">
            <Navbar2/>
        </div>

        <div className="checkout-screen container py-5">
            <div className="row">
                <div className="col-md-8">
                    <h2 className="mb-4">Checkout</h2>

                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <h4>Shipping Information</h4>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Full Name</label>
                                    <input 
                                            type="text" 
                                            className="form-control" 
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                        <label className="form-label">Email</label>
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                </div>
                            </div>

                            <div className="mb-3">
                            <label className="form-label">Address</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        required
                                    />
                            </div>

                            <div className="row">
                            <div className="col-md-4 mb-3">
                                        <label className="form-label">City</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="city"
                                            value={formData.city}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">State</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="state"
                                            value={formData.state}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">ZIP Code</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="zip"
                                            value={formData.zip}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                            </div>
                        </div>


                        <div className="mb-4">
                            <h4>Payment Method</h4>
                            <div className="form-check">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        name="paymentMethod"
                                        id="credit-card"
                                        value="credit-card"
                                        checked={formData.paymentMethod === 'credit-card'}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="credit-card">
                                        Credit Card
                                    </label>
                            </div>
                            <div className="form-check">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        name="paymentMethod"
                                        id="cod"
                                        value="cod"
                                        checked={formData.paymentMethod === 'cod'}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="cod">
                                        Cash on Delivery
                                    </label>
                            </div>
                        </div>
                        <button type="submit" className="btn btn-primary btn-lg w-100">
                                Place Order
                        </button>
                    </form>
                </div>

                <div className="col-md-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Order Summary</h5>
                            {cartItems.map(item => (
                                <div className="d-flex justify-content-between mb-2" key={item._id}>
                                    <span>
                                        {item.title} (x{item.quantity})
                                    </span>
                                    <span>${(item.price * item.quantity).toFixed(2)}</span>
                                </div>
                            ))}
                            <hr />
                            <div className="d-flex justify-content-between">
                                    <strong>Total:</strong>
                                    <strong>${cartTotal.toFixed(2)}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Footer/>
    </>
  )
}

export default CheckoutScreen